/* eslint-disable*/
import Util from '@/assets/libs/util'
import requestModule from '@/assets/libs/requestModule.js'

const FUNCTION_MAP = {
    start: {
        uri: '/StartScale',
        payload: {
            "scaleType": 12, 
            "port": Util.getLocalConfigs('balancaport'),
            "baudRate": 4800,
            "dataBits": 8,
            "parity": "none"
        }
    },
    stop: {
        uri: '/StopScale',
        payload: {
            "scaleType": 12,
            "port": Util.getLocalConfigs('balancaport'),
            "baudRate": 4800,
            "dataBits": 8,
            "parity": "none"
        }
    },
    get: {
        uri: '/GetWeight',
        payload: {
            "scaleType": 12,
            "port": Util.getLocalConfigs('balancaport'),
            "baudRate": 4800,
            "dataBits": 8,
            "parity": "none"
        }
    }
}

const callPerifericos = async function (CUR_FUNC) {
    return await requestModule.curlRequest(CUR_FUNC['uri'], CUR_FUNC['payload'])
        .then(response => response && response.data)
        .catch( error => {console.log(error.message); return 0})
}

export default {

    openBalancaPort: function () {
        return callPerifericos(FUNCTION_MAP['start'])
        // Mock para teste
        // return {result: {error: false, portAlreadyClosed: false, message: "Porta aberta com sucesso!"}}
    },
    closeBalancaPort: function () {
        return callPerifericos(FUNCTION_MAP['stop'])
        // Mock para teste
        // return {result: {error: false, portAlreadyClosed: false, message: "Porta fechada com sucesso!"}}
    },
    getWeight: function () {
        return callPerifericos(FUNCTION_MAP['get'])
        // Mock para teste
        // return {result: {error: false, peso: 0.444, portAlreadyClosed: false, message: "Peso lido com sucesso!"}}
    }

}



// WEBPACK FOOTER //
// ./src/assets/controllers/BalancaController.js